import React from "react";
import {Container, Image} from "../../../components";
import interactionWithLaw from 'assets/images/interaction-with-law.svg';
import interactionWithConomica from 'assets/images/interaction-with-conomica.svg';
import interactionWithConomicaMobile from 'assets/images/interaction-with-conomica-mobile.svg';
import interactionWithLawMobile from 'assets/images/interaction-with-law-mobile.svg';

import styles from "./HowItWorks.module.scss";
import {useWindowWidth} from "../../../components/pages/detailed-project/hooks";

const heroFeatures = [
  "Платформа предоставляет услуги по заключению сделок инвестирования в рамках 259 ФЗ и состоит в реестре Операторов инвестиционных платформ Банка России.",
  "Заемщиками могут выступать исключительно юридические лица в статусе ООО и/или АО.",
  "Сделки осуществляются по принципу коллективного софинансирования – множество инвесторов выступают в качестве инвесторов для заёмщика.",
];

const platformFacts = [
  "берёт на себя весь цикл взыскания, в случае просрочки исполнения обязательств со стороны заёмщика, включая обращение требования к предмету залога (обеспечения)",
  "информация о сделках, размещенная на платформе, не является публичной офертой и адресована лицам, зарегистрированным на Платформе",
  "не является стороной сделки займа",
  "не привлекает инвестиционные средства в собственный капитал",
  "предоставляет исключительно техническое решение для прямого взаимодействия инвестора и заёмщика",
];

const underwritingSteps = [
  "Оценка платежеспособности заемщика",
  "Оценка платежеспособности контрагентов",
  "Проверка правовой устойчивости прав требования, выступающих в качестве обеспечения",
];

const safetyCards = [
  {
    title: "Номинальный счет в банке Точка",
    texts: [
      "Номинальный счет - особая категория счетов, применяемая для хранения средств, права на которые принадлежат третьим лицам.",
      "Для любых платежей, связанных со сделками своих клиентов, Кономика использует номинальный счёт, открытый в рамках 259 ФЗ",
    ],
  },
  {
    title: "Надежный контроль денежных средств",
    texts: [
      "Использование номинальных счетов находится под особым банковским контролем. Дополнительно программный комплекс платформы ведет отдельный учет по каждой сделке создавая виртуальные субсчета.",
      "При возврате средств по займу за счет платежа от контрагента средства так же поступают напрямую на номинальный счет и распределяются между инвесторами.",
    ],
  },
];

const startSteps = [
  {
    title: "Регистрация",
    text: "Регистрация на платформе занимает пару минут: вам необходимо создать пару логин-пароль для создания личного кабинета.",
  },
  {
    title: "Верификация",
    text: "Для получения доступа к полному функционалу платформы инвестору, и заемщику необходимо пройти верификацию в электронном режиме.",
  },
  {
    title: "Заключение сделки",
    text: "Заключение сделок на платформе происходит с использованием внутренней ЭЦП",
  },
];

const checkIcon = (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
  </svg>
);

const HowItWorks = () => {
  const isMobile = useWindowWidth();
  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <Container>
          <div className={styles.heroGrid}>
            <div>
              <h1 className={styles.heroTitle}>
                <span className={styles.accent}>Платформа Кономика-займы</span>
                {" "}— это инструмент инвестирования в инновационный для рынка продукт —{" "}
                займы, обеспеченные залогом дебиторской задолженности.
              </h1>
              <p className={styles.heroLead}>
                Платформа позволяет частным инвесторам заключать инвестиционные сделки, обеспечением в которых выступают текущие требования заёмщика к своим контрагентам.
              </p>
            </div>

            <ul className={styles.checkList}>
              {heroFeatures.map((feature) => (
                <li className={styles.checkItem} key={feature}>
                  <span className={styles.check}>{checkIcon}</span>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </Container>
      </section>

      <section className={`${styles.section} ${styles.sectionSoft}`}>
        <Container>
          <div className={styles.head}>
            <h2 className={styles.title}>Платформа Кономика-займы:</h2>
          </div>
          <ul className={`${styles.checkList} ${styles.checkListGrid}`}>
            {platformFacts.map((fact) => (
              <li className={styles.checkItem} key={fact}>
                <span className={styles.check}>{checkIcon}</span>
                {fact}
              </li>
            ))}
          </ul>

          <div className={styles.diagram}>
            <Image src={isMobile? interactionWithLawMobile :interactionWithLaw} alt={''} className={styles.diagramImage}/>
          </div>
        </Container>
      </section>

      <section className={styles.section}>
        <Container>
          <div className={`${styles.head} ${styles.headWide}`}>
            <span className={styles.badge}>
              Правовая надстройка, используемая на нашей платформе
            </span>
            <h2 className={styles.title}>
              Команда платформы, используя весь накопленный опыт группы компании
              Conomica, внедрила механизм, целью которого является сделать инвестирование
              в рамках 259 ФЗ безопаснее и надежнее.
            </h2>
            <p className={styles.text}>
              Дополнительно к стандартному механизму инвестирования (в рамках 259 ФЗ)
              специалистами Conomica создана правовая надстройка, согласно которой в
              качестве обеспечения исполнения своих обязательств по возврату займа заёмщик
              предоставляет в залог принадлежащие ему права требования к своим
              контрагентам (текущая дебиторская задолженность заёмщика).
            </p>
          </div>

          <div className={styles.diagram}>
            <Image src={isMobile? interactionWithConomicaMobile:interactionWithConomica} alt={''} className={styles.diagramImage}/>
          </div>
        </Container>
      </section>

      <section className={`${styles.section} ${styles.sectionSoft}`}>
        <Container>
          <div className={styles.head}>
            <h2 className={styles.title}>Андеррайтинг</h2>
          </div>

          <div className={styles.underwritingGrid}>
            <p className={styles.note}>
              Rescore — автоматическая система проверки контрагентов по более 30 источникам.
              Входит в группу компаний Conomica
            </p>

            <p className={styles.greenCard}>
              При проведении трехуровневого андеррайтинга и мониторинга текущей
              платежеспособности применяются технические решения компании Rescore
            </p>

            <ol className={styles.levels}>
              {underwritingSteps.map((step, index) => (
                <li className={styles.level} key={step}>
                  <span className={styles.levelNum}>{index + 1}</span>
                  {step}
                </li>
              ))}
            </ol>
          </div>
        </Container>
      </section>

      <section className={styles.section}>
        <Container>
          <div className={styles.head}>
            <h2 className={styles.title}>Безопасность средств</h2>
          </div>

          <div className={styles.cards}>
            {safetyCards.map((card) => (
              <div className={styles.card} key={card.title}>
                <div className={styles.cardIcon}>{checkIcon}</div>
                <h3 className={styles.cardTitle}>{card.title}</h3>
                {card.texts.map((text) => (
                  <p className={styles.cardText} key={text}>{text}</p>
                ))}
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className={`${styles.section} ${styles.sectionSoft}`}>
        <Container>
          <div className={styles.head}>
            <h2 className={styles.title}>Начало работы на платформе</h2>
          </div>

          <ol className={`${styles.cards} ${styles.cardsThree}`}>
            {startSteps.map((step, index) => (
              <li className={styles.card} key={step.title}>
                <div className={styles.stepNum}>{index + 1}</div>
                <h3 className={styles.cardTitle}>{step.title}</h3>
                <p className={styles.cardText}>{step.text}</p>
              </li>
            ))}
          </ol>
        </Container>
      </section>
    </div>
  );
};

export default HowItWorks;
